"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentMemberChoiceValue = exports.assignedToDefaultValue = void 0;
exports.assignedToDefaultValue = "current";
exports.currentMemberChoiceValue = "current_member";
